module.exports = __webpack_public_path__ + "img/icon_present2.5d6c53bd.svg";